import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludesSection } from './components/IncludesSection';
import { MethodSection } from './components/MethodSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { MockupSection } from './components/MockupSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="w-full min-h-screen" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <IncludesSection data-id="element-4" />
      <MethodSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <ForWhoSection data-id="element-8" />
      <ObjectionsSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <MockupSection data-id="element-11" />
      <OfferSection data-id="element-12" />
      <FaqSection data-id="element-13" />
      <ClosingSection data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}